import { CounterType } from './counter-type.enum';
var CountersHelper = /** @class */ (function () {
    function CountersHelper() {
    }
    CountersHelper.convertCounterResultsToCounters = function (countersResults) {
        var counters = {
            followers: 0,
            views: 0,
            unhelpful: 0,
            helpful: 0,
            votes: 0
        };
        countersResults.forEach(function (item) {
            switch (item.counterType) {
                case CounterType.FOLLOWER:
                    counters.followers = item.value;
                    break;
                case CounterType.VIEW:
                    counters.views = item.value;
                    break;
                case CounterType.RATING_1:
                    counters.unhelpful = item.value;
                    break;
                case CounterType.RATING_5:
                    counters.helpful = item.value;
                    break;
                case CounterType.VOTE:
                    counters.votes = item.value;
                    break;
                default:
                    break;
            }
        });
        return counters;
    };
    return CountersHelper;
}());
export { CountersHelper };
var CountersBuilder = /** @class */ (function () {
    function CountersBuilder() {
        this.counters = {
            views: 0,
            followers: 0,
            votes: 0,
            helpful: 0,
            unhelpful: 0
        };
    }
    CountersBuilder.prototype.withViews = function (views) {
        this.counters.views = views;
        return this;
    };
    CountersBuilder.prototype.withFollowers = function (followers) {
        this.counters.followers = followers;
        return this;
    };
    CountersBuilder.prototype.withVotes = function (votes) {
        this.counters.votes = votes;
        return this;
    };
    CountersBuilder.prototype.withHelpful = function (helpful) {
        this.counters.helpful = helpful;
        return this;
    };
    CountersBuilder.prototype.withUnhelpful = function (unhelpful) {
        this.counters.unhelpful = unhelpful;
        return this;
    };
    CountersBuilder.prototype.build = function () {
        return this.counters;
    };
    return CountersBuilder;
}());
export { CountersBuilder };
//# sourceMappingURL=counters-builder.js.map